//#region DevExtreme Imports

import 'devextreme/ui/toolbar'
import 'devextreme/ui/popup'

//#endregion

import { $SCOPE_SERVICE_NAME } from "../../../../services/system"
import { ConfirmOrderController } from "./confirm-order.controller"
import { ORDER_CONFIRM_SERVICE_NAME } from "../../../../services/order/order.confirm.service"
import { ORDER_SERVICE_NAME } from "../../../../services/order"
import { USER_SESSION_SERVICE_NAME } from "../../../../services/user-session"

//#region Asset Imports

import * as TEMPLATE from './confirm-order.tpl.html'
import './confirm-order.scss'

//#endregion

export const COMPONENT_NAME: string = 'confirmOrder'

export class ConfirmOrderComponent {

    controller = [
        $SCOPE_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        ORDER_SERVICE_NAME,
        ORDER_CONFIRM_SERVICE_NAME,
        ConfirmOrderController
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE

}